export class QuantityTicker {
  constructor (elem) {
    /* ELEMENTS */
    this.elem = elem
    this.upTicker = this.elem.querySelector('[data-btn-add]')
    this.label = this.elem.querySelector('[data-label]')
    this.downTicker = this.elem.querySelector('[data-btn-subtract]')
    this.valueInput = this.elem.querySelector('[data-input]')

    /* DATA */
    const defaultData = this.elem.dataset
    this.formdata = {}
    this.formdata.quantity = (defaultData.quantity !== undefined && Number.isInteger(defaultData.quantity)) ? defaultData.quantity : 1
    this.formdata.max = defaultData.max !== undefined && Number.parseInt(defaultData.max) ? defaultData.max : 100
    this.formdata.min = defaultData.min !== undefined && Number.parseInt(defaultData.min) ? defaultData.min : 1

    /* STATE */

    /* EVENTS */
    this.setupEvents()

    /* INIT */
    this.initialise()
  }

  correctdefaultquantity () {
    if (this.formdata.quantity > this.formdata.max) {
      return this.formdata.max
    }
    if (this.formdata.quantity < this.formdata.min) {
      return this.formdata.min
    }
    return this.formdata.quantity
  }

  initialise () {
    this.formdata.quantity = this.correctdefaultquantity()
    this.setValue()
    this.setMinState()
    this.setMaxState()
  }

  setValue () {
    this.valueInput.value = this.formdata.quantity
  }

  setMinState () {
    if (this.formdata.quantity <= this.formdata.min) {
      this.downTicker.setAttribute('disabled', 'disabled')
    } else {
      this.downTicker.removeAttribute('disabled')
    }
  }

  setMaxState () {
    if (this.formdata.quantity >= this.formdata.max) {
      this.upTicker.setAttribute('disabled', 'disabled')
    } else {
      this.upTicker.removeAttribute('disabled')
    }
  }

  setupEvents () {
    this.upTicker.addEventListener('click', () => {
      this.increment()
    })

    this.downTicker.addEventListener('click', () => {
      this.decrement()
    })
  }

  decrement () {
    this.formdata.quantity--
    this.setValue()
    this.setMinState()
    this.setMaxState()
  }

  increment () {
    this.formdata.quantity++
    this.setValue()
    this.setMinState()
    this.setMaxState()
  }
}

export const setupQuantityTicker = (elem) => {
  const qticker = new QuantityTicker(elem)
  return qticker
}
